import { errorServeiceHandler, makeQueryStringDync } from '../helper'
const state = {
}
const getters = {
}
const mutations = {
}
const actions = {
    getPDFDetails: (context) => {
        return new Promise((resolve, reject) => {
            let url = '/lco/v1/downloadfile'
            fetch(context.getters.baseUrl + url, {
                method: 'GET'
            })
            .then(errorServeiceHandler)
            .then((response) => {
                return response.json()
            }).then((data) => {
                resolve(data)
            }).catch((error) => {
                if (context.getters.getMode == "development") {
                   resolve([{"iddownloadablefiles":"17","name":"COVID-19 AWARENESS","filename":"Userguide_v1.11.pdf","purpose":"LCO Portal User Guide","created":"2020-09-21 11:58:00","type":"PDF","url":"https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/download\/Userguide_v1.11.pdf?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAZTWJZDEUJKBH6SWE%2F20201209%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20201209T145832Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=488e11278238410304d36235a62833f80b8c2ec404535822fc19294c9fe9e430","thumbnail":null,"category":null,"categoryid":null},{"iddownloadablefiles":"19","name":"GST FAQ","filename":"FREQUENTLY_ASKED_QUESTIONS_GST.pdf","purpose":"GST FAQ","created":"2020-10-14 18:24:04","type":"PDF","url":"https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/download\/FREQUENTLY_ASKED_QUESTIONS_GST.pdf?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAZTWJZDEUJKBH6SWE%2F20201209%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20201209T145832Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=8771dd3a71468daef3e8cf094769b8c0014a939f1c785e40f76c27c1739da6c0","thumbnail":null,"category":null,"categoryid":null},{"iddownloadablefiles":"20","name":"Axis Bank Easy Pay Slip","filename":"axiseasypayslip.pdf","purpose":"Axis Bank Easy Pay Slip","created":"2020-10-14 18:24:42","type":"PDF","url":"https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/download\/axiseasypayslip.pdf?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAZTWJZDEUJKBH6SWE%2F20201209%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20201209T145832Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=f87cc1e9b679ea2a89ea48e68165d58111d481d9a93a3a8a555eb70b22c5ce08","thumbnail":null,"category":null,"categoryid":null},{"iddownloadablefiles":"21","name":"MIB Letter","filename":"MIB_Letter_to_ALL_DM.pdf","purpose":"MIB Letter","created":"2020-10-14 18:25:21","type":"PDF","url":"https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/download\/MIB_Letter_to_ALL_DM.pdf?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAZTWJZDEUJKBH6SWE%2F20201209%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20201209T145832Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=c7eda036cfa4b01f0c7c8d3293ea380e65ead7603fc3aa971da9613368d6531b","thumbnail":null,"category":null,"categoryid":null},{"iddownloadablefiles":"22","name":"MIB Advisory","filename":"MIB_Advisory_to_MSO_LCO.pdf","purpose":"MIB Advisory","created":"2020-10-14 18:26:02","type":"PDF","url":"https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/download\/MIB_Advisory_to_MSO_LCO.pdf?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAZTWJZDEUJKBH6SWE%2F20201209%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20201209T145832Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=974203cca5cacd931057449c0d03fe5b409e7ef17a98051f57702bad9cf10bb4","thumbnail":null,"category":null,"categoryid":null},{"iddownloadablefiles":"23","name":"Third Party Deposit Authorization","filename":"authorisation_letter.pdf","purpose":"Third Party Deposit Authorization","created":"2020-10-14 18:27:09","type":"PDF","url":"https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/download\/authorisation_letter.pdf?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAZTWJZDEUJKBH6SWE%2F20201209%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20201209T145832Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=9de969b8be753a64a78f5705b9ef1a264710820a1a94a997572933bd74bb2308","thumbnail":null,"category":null,"categoryid":null},{"iddownloadablefiles":"26","name":"Axis EasyPay Circular","filename":"PDF_Notification.pdf","purpose":"Axis EasyPay Circular","created":"2020-10-14 18:51:26","type":"PDF","url":"https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/download\/PDF_Notification.pdf?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAZTWJZDEUJKBH6SWE%2F20201209%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20201209T145832Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=9e0b6a7569e3b7d74e88772e9891d6aa10733a4f3680343846a2029176ca579b","thumbnail":null,"category":null,"categoryid":null},{"iddownloadablefiles":"35","name":"HELP VIDEOS","filename":null,"purpose":"Helping","created":"2020-12-09 12:32:55","type":"PDF","url":"https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/download\/?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAZTWJZDEUJKBH6SWE%2F20201209%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20201209T145832Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=dfef63c2a9e085a9a7dc0869d38c23b38f874e53036258570b5002dc3b21bb5c","thumbnail":null,"category":null,"categoryid":null}, {"iddownloadablefiles":"35","name":"COVID-19 AWARENESS","filename":null,"purpose":"covid","created":"2020-12-09 12:32:55","type":"PDF","url":"https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/download\/?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAZTWJZDEUJKBH6SWE%2F20201209%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20201209T145832Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=dfef63c2a9e085a9a7dc0869d38c23b38f874e53036258570b5002dc3b21bb5c","thumbnail":null,"category":null,"categoryid":null}])
                    return
                }
                reject(error);
            });
        });
    },
    getPDFLink: (context,filename) => {
        return new Promise( (resolve, reject) => {
            let url = '/lco/v1/downloadfile/'   
            fetch(context.getters.baseUrl + url + filename, {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {

                    resolve(data)

                }).catch((error) => {
                    reject(error);
                });
        });
    },
    getVideoDetails: (context,payload) => {
        return new Promise( (resolve, reject) => {
            let queryStr = ''
            queryStr = makeQueryStringDync(payload)
            let url = '/lco/v1/downloadfile'  
            fetch(context.getters.baseUrl + url + queryStr, {
                method: 'GET'
            })
            .then(errorServeiceHandler)
            .then((response) => {
                return response.json()
            }).then((data) => {
                if (context.getters.getMode == "development") {
                    resolve(  
                        [{"iddownloadablefiles":"27","name":"Help Vedio -1 ","filename":null,"purpose":"Helping","created":"2020-12-07 10:08:36","type":"MP4","url":"https:\/\/d9xhhw2q0vx7g.cloudfront.net\/videos\/7JoYo5Xf\/9ufqizffEy1C_manifest.mpd","thumbnail":"http:\/\/indigital.co.in\/media\/images\/IN_Digital_Direct%20Point%20Subscribers.png","category":"HINDI","categoryid":"1"},{"iddownloadablefiles":"28","name":"Help Vedio -1 ","filename":null,"purpose":"Helping","created":"2020-12-07 10:08:36","type":"MP4","url":"https:\/\/d9xhhw2q0vx7g.cloudfront.net\/videos\/7JoYo5Xf\/9ufqizffEy1C_manifest.mpd","thumbnail":"http:\/\/indigital.co.in\/media\/images\/IN_Digital_Direct%20Point%20Subscribers.png","category":"ENGLISH","categoryid":"1"},{"iddownloadablefiles":"29","name":"Help Vedio -2","filename":null,"purpose":"Helping","created":"2020-12-07 10:08:36","type":"MP4","url":"https:\/\/d9xhhw2q0vx7g.cloudfront.net\/videos\/7JoYo5Xf\/9ufqizffEy1C_manifest.mpd","thumbnail":"http:\/\/indigital.co.in\/media\/images\/IN_Digital_Direct%20Point%20Subscribers.png","category":"HINDI","categoryid":"2"},{"iddownloadablefiles":"30","name":"Help Vedio -2","filename":null,"purpose":"Helping","created":"2020-12-07 10:08:36","type":"MP4","url":"https:\/\/d9xhhw2q0vx7g.cloudfront.net\/videos\/7JoYo5Xf\/9ufqizffEy1C_manifest.mpd","thumbnail":"http:\/\/indigital.co.in\/media\/images\/IN_Digital_Direct%20Point%20Subscribers.png","category":"ENGLISH","categoryid":"2"},{"iddownloadablefiles":"31","name":"Help Vedio -3","filename":null,"purpose":"Helping","created":"2020-12-07 10:08:36","type":"MP4","url":"https:\/\/d9xhhw2q0vx7g.cloudfront.net\/videos\/7JoYo5Xf\/9ufqizffEy1C_manifest.mpd","thumbnail":"http:\/\/indigital.co.in\/media\/images\/IN_Digital_Direct%20Point%20Subscribers.png","category":"HINDI","categoryid":"3"},{"iddownloadablefiles":"32","name":"Help Vedio -3","filename":null,"purpose":"Helping","created":"2020-12-07 10:08:36","type":"MP4","url":"https:\/\/d9xhhw2q0vx7g.cloudfront.net\/videos\/7JoYo5Xf\/9ufqizffEy1C_manifest.mpd","thumbnail":"http:\/\/indigital.co.in\/media\/images\/IN_Digital_Direct%20Point%20Subscribers.png","category":"ENGLISH","categoryid":"3"},{"iddownloadablefiles":"33","name":"Help Vedio -4","filename":null,"purpose":"Helping","created":"2020-12-07 10:08:36","type":"MP4","url":"https:\/\/d9xhhw2q0vx7g.cloudfront.net\/videos\/7JoYo5Xf\/9ufqizffEy1C_manifest.mpd","thumbnail":"http:\/\/indigital.co.in\/media\/images\/IN_Digital_Direct%20Point%20Subscribers.png","category":"HINDI","categoryid":"4"},{"iddownloadablefiles":"34","name":"Help Vedio -4","filename":null,"purpose":"Helping","created":"2020-12-07 10:08:36","type":"MP4","url":"https:\/\/d9xhhw2q0vx7g.cloudfront.net\/videos\/7JoYo5Xf\/9ufqizffEy1C_manifest.mpd","thumbnail":"http:\/\/indigital.co.in\/media\/images\/IN_Digital_Direct%20Point%20Subscribers.png","category":"ENGLISH","categoryid":"4"}])
                    return
                }
                resolve(data)
            }).catch((error) => {
                if (context.getters.getMode == "development") {
                    resolve([
                        {
                            "iddownloadablefiles": "45",
                            "name": "MODIFY PACKS / SCHEDULE PACKS / HARDWARE REPLACEMENT / MANAGING TICKETS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_ENGLISH.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "ENGLISH",
                            "categoryid": "1"
                        },
                        {
                            "iddownloadablefiles": "46",
                            "name": "MODIFY PACKS / SCHEDULE PACKS / HARDWARE REPLACEMENT / MANAGING TICKETS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_HINDI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "HINDI",
                            "categoryid": "1"
                        },
                        {
                            "iddownloadablefiles": "47",
                            "name": "MODIFY PACKS / SCHEDULE PACKS / HARDWARE REPLACEMENT / MANAGING TICKETS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_MARATHI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "MARATHI",
                            "categoryid": "1"
                        },
                        {
                            "iddownloadablefiles": "48",
                            "name": "MODIFY PACKS / SCHEDULE PACKS / HARDWARE REPLACEMENT / MANAGING TICKETS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_GUJARATI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "GUJARATI",
                            "categoryid": "1"
                        },
                        {
                            "iddownloadablefiles": "49",
                            "name": "MODIFY PACKS / SCHEDULE PACKS / HARDWARE REPLACEMENT / MANAGING TICKETS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_BENGALI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "BANGALI",
                            "categoryid": "1"
                        },
                        {
                            "iddownloadablefiles": "50",
                            "name": "MODIFY PACKS / SCHEDULE PACKS / HARDWARE REPLACEMENT / MANAGING TICKETS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_ODIA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "ODIA",
                            "categoryid": "1"
                        },
                        {
                            "iddownloadablefiles": "51",
                            "name": "MODIFY PACKS / SCHEDULE PACKS / HARDWARE REPLACEMENT / MANAGING TICKETS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_TAMIL.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "TAMIL",
                            "categoryid": "1"
                        },
                        {
                            "iddownloadablefiles": "52",
                            "name": "MODIFY PACKS / SCHEDULE PACKS / HARDWARE REPLACEMENT / MANAGING TICKETS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_TELUGU.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "TELUGU",
                            "categoryid": "1"
                        },
                        {
                            "iddownloadablefiles": "53",
                            "name": "MODIFY PACKS / SCHEDULE PACKS / HARDWARE REPLACEMENT / MANAGING TICKETS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_KANNADA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "KANNADA",
                            "categoryid": "1"
                        },
                        {
                            "iddownloadablefiles": "54",
                            "name": "MODIFY PACKS / SCHEDULE PACKS / HARDWARE REPLACEMENT / MANAGING TICKETS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_PunjabiiI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "PUNJABI",
                            "categoryid": "1"
                        },
                        {
                            "iddownloadablefiles": "55",
                            "name": "MANAGE SUBSCRIBERS / RENEW PACKS / LATEST ANNOUNCEMENTS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/%281%29Manage%20Subscribers%20%282%29Renew%20Packs%20%283%29Latest%20Announcements_ENGLISH.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "ENGLISH",
                            "categoryid": "2"
                        },
                        {
                            "iddownloadablefiles": "56",
                            "name": "MANAGE SUBSCRIBERS / RENEW PACKS / LATEST ANNOUNCEMENTS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/%281%29Manage%20Subscribers%20%282%29Renew%20Packs%20%283%29Latest%20Announcements_HINDI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "HINDI",
                            "categoryid": "2"
                        },
                        {
                            "iddownloadablefiles": "57",
                            "name": "MANAGE SUBSCRIBERS / RENEW PACKS / LATEST ANNOUNCEMENTS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/%281%29Manage%20Subscribers%20%282%29Renew%20Packs%20%283%29Latest%20Announcements_MARATHI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "MARATHI",
                            "categoryid": "2"
                        },
                        {
                            "iddownloadablefiles": "58",
                            "name": "MANAGE SUBSCRIBERS / RENEW PACKS / LATEST ANNOUNCEMENTS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/%281%29Manage%20Subscribers%20%282%29Perform%20Transactions%20%283%29Latest%20Announcements_GUJARATI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "GUJARATI",
                            "categoryid": "2"
                        },
                        {
                            "iddownloadablefiles": "59",
                            "name": "MANAGE SUBSCRIBERS / RENEW PACKS / LATEST ANNOUNCEMENTS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/%281%29Manage%20Subscribers%20%282%29Renew%20Packs%20%283%29Latest%20Announcements_BENGALI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "BANGALI",
                            "categoryid": "2"
                        },
                        {
                            "iddownloadablefiles": "60",
                            "name": "MANAGE SUBSCRIBERS / RENEW PACKS / LATEST ANNOUNCEMENTS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/%281%29Manage%20Subscribers%20%282%29Perform%20Transactions%20%283%29Latest%20Announcements_ODIA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "ODIA",
                            "categoryid": "2"
                        },
                        {
                            "iddownloadablefiles": "61",
                            "name": "MANAGE SUBSCRIBERS / RENEW PACKS / LATEST ANNOUNCEMENTS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/%281%29Manage%20Subscribers%20%282%29Renew%20Packs%20%283%29Latest%20Announcements_TAMIL.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "TAMIL",
                            "categoryid": "2"
                        },
                        {
                            "iddownloadablefiles": "62",
                            "name": "MANAGE SUBSCRIBERS / RENEW PACKS / LATEST ANNOUNCEMENTS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/%281%29Manage%20Subscribers%20%282%29Renew%20Packs%20%283%29Latest%20Announcements_TELUGU.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "TELUGU",
                            "categoryid": "2"
                        },
                        {
                            "iddownloadablefiles": "63",
                            "name": "MANAGE SUBSCRIBERS / RENEW PACKS / LATEST ANNOUNCEMENTS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/%281%29Manage%20Subscribers%20%282%29Renew%20Packs%20%283%29Latest%20Announcements_KANNADA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "KANNADA",
                            "categoryid": "2"
                        },
                        {
                            "iddownloadablefiles": "64",
                            "name": "MANAGE SUBSCRIBERS / RENEW PACKS / LATEST ANNOUNCEMENTS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/%281%29Manage%20Subscribers%20%282%29Renew%20Packs%20%283%29Latest%20Announcements_PunjabiiI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "PUNJABI",
                            "categoryid": "2"
                        },
                        {
                            "iddownloadablefiles": "65",
                            "name": "BULK PROCESSING /  CREATE SUBUSERS / COMPREHENSIVE REPORTS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video3/%281%29Bulk%20Processing%20%282%29Create%20Sub%20Users%20%283%29Comprehensive%20Reports_ENGLISH.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "ENGLISH",
                            "categoryid": "3"
                        },
                        {
                            "iddownloadablefiles": "66",
                            "name": "BULK PROCESSING /  CREATE SUBUSERS / COMPREHENSIVE REPORTS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video3/%281%29Bulk%20Processing%20%282%29Create%20Sub%20Users%20%283%29%20Comprehensive%20Reports_HINDI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "HINDI",
                            "categoryid": "3"
                        },
                        {
                            "iddownloadablefiles": "67",
                            "name": "BULK PROCESSING /  CREATE SUBUSERS / COMPREHENSIVE REPORTS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video3/%281%29Bulk%20Processing%20%282%29Create%20Sub%20Users%20%283%29%20Comprehensive%20Reports_MARATHI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "MARATHI",
                            "categoryid": "3"
                        },
                        {
                            "iddownloadablefiles": "68",
                            "name": "BULK PROCESSING /  CREATE SUBUSERS / COMPREHENSIVE REPORTS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video3/%281%29Bulk%20Processing%20%282%29Create%20Sub%20Users%20%283%29Comprehensive%20Reports_GUJARATI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "GUJARATI",
                            "categoryid": "3"
                        },
                        {
                            "iddownloadablefiles": "69",
                            "name": "BULK PROCESSING /  CREATE SUBUSERS / COMPREHENSIVE REPORTS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video3/%281%29Bulk%20Processing%20%282%29Create%20Sub%20Users%20%283%29Comprehensive%20Reports_BENGALI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "BANGALI",
                            "categoryid": "3"
                        },
                        {
                            "iddownloadablefiles": "70",
                            "name": "BULK PROCESSING /  CREATE SUBUSERS / COMPREHENSIVE REPORTS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video3/%281%29Bulk%20Processing%20%282%29Create%20Sub%20Users%20%283%29%20Comprehensive%20Reports_ODIA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "ODIA",
                            "categoryid": "3"
                        },
                        {
                            "iddownloadablefiles": "71",
                            "name": "BULK PROCESSING /  CREATE SUBUSERS / COMPREHENSIVE REPORTS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video3/%281%29Bulk%20Processing%20%282%29Create%20Sub%20Users%20%283%29%20Comprehensive%20Reports_TAMIL.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "TAMIL",
                            "categoryid": "3"
                        },
                        {
                            "iddownloadablefiles": "72",
                            "name": "BULK PROCESSING /  CREATE SUBUSERS / COMPREHENSIVE REPORTS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video3/%281%29Bulk%20Processing%20%282%29Create%20Sub%20Users%20%283%29%20Comprehensive%20Reports_TELUGU.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "TELUGU",
                            "categoryid": "3"
                        },
                        {
                            "iddownloadablefiles": "73",
                            "name": "BULK PROCESSING /  CREATE SUBUSERS / COMPREHENSIVE REPORTS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video3/%281%29Bulk%20Processing%20%282%29Create%20Sub%20Users%20%283%29%20Comprehensive%20Reports_KANNADA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "KANNADA",
                            "categoryid": "3"
                        },
                        {
                            "iddownloadablefiles": "74",
                            "name": "BULK PROCESSING /  CREATE SUBUSERS / COMPREHENSIVE REPORTS",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video3/%281%29Bulk%20Processing%20%282%29Create%20Sub%20Users%20%283%29%20Comprehensive%20Reports_PunjabiiI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO.png",
                            "category": "PUNJABI",
                            "categoryid": "3"
                        },
                        {
                            "iddownloadablefiles": "76",
                            "name": "LCO MOBILE APP",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/%281%29Manage%20Subscribers%20%282%29Perform%20Transactions%20%283%29Latest%20Announcements_ENGLISH.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO%20APP.png",
                            "category": "ENGLISH",
                            "categoryid": "4"
                        },
                        {
                            "iddownloadablefiles": "77",
                            "name": "LCO MOBILE APP",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/%281%29Manage%20Subscribers%20%282%29Perform%20Transactions%20%283%29Latest%20Announcements_HINDI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO%20APP.png",
                            "category": "HINDI",
                            "categoryid": "4"
                        },
                        {
                            "iddownloadablefiles": "78",
                            "name": "LCO MOBILE APP",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/%281%29Manage%20Subscribers%20%282%29Perform%20Transactions%20%283%29Latest%20Announcements_MARATHI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO%20APP.png",
                            "category": "MARATHI",
                            "categoryid": "4"
                        },
                        {
                            "iddownloadablefiles": "79",
                            "name": "LCO MOBILE APP",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/%281%29Manage%20Subscribers%20%282%29Perform%20Transactions%20%283%29Latest%20Announcements_GUJARATI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO%20APP.png",
                            "category": "GUJARATI",
                            "categoryid": "4"
                        },
                        {
                            "iddownloadablefiles": "80",
                            "name": "LCO MOBILE APP",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/%281%29Manage%20Subscribers%20%282%29Perform%20Transactions%20%283%29Latest%20Announcements_GUJARATI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO%20APP.png",
                            "category": "BENGALI",
                            "categoryid": "4"
                        },
                        {
                            "iddownloadablefiles": "81",
                            "name": "LCO MOBILE APP",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/%281%29Manage%20Subscribers%20%282%29Perform%20Transactions%20%283%29Latest%20Announcements_ODIA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO%20APP.png",
                            "category": "ODIA",
                            "categoryid": "4"
                        },
                        {
                            "iddownloadablefiles": "82",
                            "name": "LCO MOBILE APP",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/%281%29Manage%20Subscribers%20%282%29Perform%20Transactions%20%283%29Latest%20Announcements_TAMIL.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO%20APP.png",
                            "category": "TAMIL",
                            "categoryid": "4"
                        },
                        {
                            "iddownloadablefiles": "83",
                            "name": "LCO MOBILE APP",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/%281%29Manage%20Subscribers%20%282%29Perform%20Transactions%20%283%29Latest%20Announcements_TELUGU.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO%20APP.png",
                            "category": "TELUGU",
                            "categoryid": "4"
                        },
                        {
                            "iddownloadablefiles": "84",
                            "name": "LCO MOBILE APP",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/%281%29Manage%20Subscribers%20%282%29Perform%20Transactions%20%283%29Latest%20Announcements_KANNADA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO%20APP.png",
                            "category": "KANNADA",
                            "categoryid": "4"
                        },
                        {
                            "iddownloadablefiles": "85",
                            "name": "LCO MOBILE APP",
                            "filename": "HELP VIDEO",
                            "purpose": "HELP VIDEO",
                            "created": "2024-06-14 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/%281%29Manage%20Subscribers%20%282%29Perform%20Transactions%20%283%29Latest%20Announcements_PunjabiiI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/FeatureOverview_Purple_Thumbnails_LCO%20APP.png",
                            "category": "PUNJABI",
                            "categoryid": "4"
                        },
                        {
                            "iddownloadablefiles": "207",
                            "name": "Modifying Packs / Schedule Packs",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video%20-%20%281%29Modifying%20Packs%20%2B%20Schedule%20Packs-ENGLISH.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "ENGLISH",
                            "categoryid": "6"
                        },
                        {
                            "iddownloadablefiles": "208",
                            "name": "Modifying Packs / Schedule Packs",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_HINDI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "HINDI",
                            "categoryid": "6"
                        },
                        {
                            "iddownloadablefiles": "209",
                            "name": "Modifying Packs / Schedule Packs",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_MARATHI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "MARATHI",
                            "categoryid": "6"
                        },
                        {
                            "iddownloadablefiles": "210",
                            "name": "Modifying Packs / Schedule Packs",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_GUJARATI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "GUJARATI",
                            "categoryid": "6"
                        },
                        {
                            "iddownloadablefiles": "211",
                            "name": "Modifying Packs / Schedule Packs",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_BENGALI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "BENGALI",
                            "categoryid": "6"
                        },
                        {
                            "iddownloadablefiles": "212",
                            "name": "Modifying Packs / Schedule Packs",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_ODIA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "ODIA",
                            "categoryid": "6"
                        },
                        {
                            "iddownloadablefiles": "213",
                            "name": "Modifying Packs / Schedule Packs",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_TAMIL.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "TAMIL",
                            "categoryid": "6"
                        },
                        {
                            "iddownloadablefiles": "214",
                            "name": "Modifying Packs / Schedule Packs",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_TELUGU.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "TELUGU",
                            "categoryid": "6"
                        },
                        {
                            "iddownloadablefiles": "215",
                            "name": "Modifying Packs / Schedule Packs",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_KANNADA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "KANNADA",
                            "categoryid": "6"
                        },
                        {
                            "iddownloadablefiles": "216",
                            "name": "Modifying Packs / Schedule Packs",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/%281%29Modifying%20Packs%20%282%29Schedule%20Packs%20%283%29Hardware%20Replacement%20%284%29Managing%20Tickets_PunjabiiI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "PUNJABI",
                            "categoryid": "6"
                        },
                        {
                            "iddownloadablefiles": "217",
                            "name": "Retrack / Hardware Replacement",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%282%29Retrack%20%2B%20Hardware%20Replacement-ENGLISH.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "ENGLISH",
                            "categoryid": "7"
                        },
                        {
                            "iddownloadablefiles": "218",
                            "name": "Retrack / Hardware Replacement",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%282%29Retrack%20%2B%20Hardware%20Replacement-HINDI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "HINDI",
                            "categoryid": "7"
                        },
                        {
                            "iddownloadablefiles": "219",
                            "name": "Retrack / Hardware Replacement",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%282%29Retrack%20%2B%20Hardware%20Replacement-MARATHI%281%29.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "MARATHI",
                            "categoryid": "7"
                        },
                        {
                            "iddownloadablefiles": "220",
                            "name": "Retrack / Hardware Replacement",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%282%29Retrack%20%2B%20Hardware%20Replacement-GUJARATI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "GUJARATI",
                            "categoryid": "7"
                        },
                        {
                            "iddownloadablefiles": "221",
                            "name": "Retrack / Hardware Replacement",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%282%29Retrack%20%2B%20Hardware%20Replacement-BANGALI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "BENGALI",
                            "categoryid": "7"
                        },
                        {
                            "iddownloadablefiles": "222",
                            "name": "Retrack / Hardware Replacement",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%282%29Retrack%20%2B%20Hardware%20Replacement-ODIA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "ODIA",
                            "categoryid": "7"
                        },
                        {
                            "iddownloadablefiles": "223",
                            "name": "Retrack / Hardware Replacement",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%282%29Retrack%20%2B%20Hardware%20Replacement-TAMIL.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "TAMIL",
                            "categoryid": "7"
                        },
                        {
                            "iddownloadablefiles": "224",
                            "name": "Retrack / Hardware Replacement",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%282%29Retrack%20%2B%20Hardware%20Replacement-TELUGU.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "TELUGU",
                            "categoryid": "7"
                        },
                        {
                            "iddownloadablefiles": "225",
                            "name": "Retrack / Hardware Replacement",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%282%29Retrack%20%2B%20Hardware%20Replacement-KANNADA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "KANNADA",
                            "categoryid": "7"
                        },
                        {
                            "iddownloadablefiles": "226",
                            "name": "Retrack / Hardware Replacement",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%282%29Retrack%20%2B%20Hardware%20Replacement-PunjabiiI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "PUNJABI",
                            "categoryid": "7"
                        },
                        {
                            "iddownloadablefiles": "227",
                            "name": "Customer Profile / KYC /  Managing Tickets",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%283%29Customer%20Profile%20%2B%20KYC%20%2B%20Managing%20Tickets-ENGLISH.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "ENGLISH",
                            "categoryid": "8"
                        },
                        {
                            "iddownloadablefiles": "228",
                            "name": "Customer Profile / KYC /  Managing Tickets",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%283%29Customer%20Profile%20%2B%20KYC%20%2B%20Managing%20Tickets-HINDI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "HINDI",
                            "categoryid": "8"
                        },
                        {
                            "iddownloadablefiles": "229",
                            "name": "Customer Profile / KYC /  Managing Tickets",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%283%29Customer%20Profile%20%2B%20KYC%20%2B%20Managing%20Tickets-MARATHI%281%29.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "MARATHI",
                            "categoryid": "8"
                        },
                        {
                            "iddownloadablefiles": "230",
                            "name": "Customer Profile / KYC /  Managing Tickets",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%283%29Customer%20Profile%20%2B%20KYC%20%2B%20Managing%20Tickets-GUJARATI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "GUJARATI",
                            "categoryid": "8"
                        },
                        {
                            "iddownloadablefiles": "231",
                            "name": "Customer Profile / KYC /  Managing Tickets",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%283%29Customer%20Profile%20%2B%20KYC%20%2B%20Managing%20Tickets-BANGALI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "BENGALI",
                            "categoryid": "8"
                        },
                        {
                            "iddownloadablefiles": "232",
                            "name": "Customer Profile / KYC /  Managing Tickets",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%283%29Customer%20Profile%20%2B%20KYC%20%2B%20Managing%20Tickets-ODIA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "ODIA",
                            "categoryid": "8"
                        },
                        {
                            "iddownloadablefiles": "233",
                            "name": "Customer Profile / KYC /  Managing Tickets",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%283%29Customer%20Profile%20%2B%20KYC%20%2B%20Managing%20Tickets-TAMIL.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "TAMIL",
                            "categoryid": "8"
                        },
                        {
                            "iddownloadablefiles": "234",
                            "name": "Customer Profile / KYC /  Managing Tickets",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%283%29Customer%20Profile%20%2B%20KYC%20%2B%20Managing%20Tickets-TELUGU.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "TELUGU",
                            "categoryid": "8"
                        },
                        {
                            "iddownloadablefiles": "235",
                            "name": "Customer Profile / KYC /  Managing Tickets",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%283%29Customer%20Profile%20%2B%20KYC%20%2B%20Managing%20Tickets-KANNADA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "KANNADA",
                            "categoryid": "8"
                        },
                        {
                            "iddownloadablefiles": "236",
                            "name": "Customer Profile / KYC /  Managing Tickets",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-%283%29Customer%20Profile%20%2B%20KYC%20%2B%20Managing%20Tickets-PunjabiiI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "PUNJABI",
                            "categoryid": "8"
                        },
                        {
                            "iddownloadablefiles": "237",
                            "name": "Manage Subscribers",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Manage%20Subscribers-ENGLISH.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "ENGLISH",
                            "categoryid": "9"
                        },
                        {
                            "iddownloadablefiles": "238",
                            "name": "Manage Subscribers",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Manage%20Subscribers-HINDI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "HINDI",
                            "categoryid": "9"
                        },
                        {
                            "iddownloadablefiles": "239",
                            "name": "Manage Subscribers",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Manage%20Subscribers-MARATHI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "MARATHI",
                            "categoryid": "9"
                        },
                        {
                            "iddownloadablefiles": "240",
                            "name": "Manage Subscribers",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Manage%20Subscribers-GUJARATI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "GUJARATI",
                            "categoryid": "9"
                        },
                        {
                            "iddownloadablefiles": "241",
                            "name": "Manage Subscribers",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Manage%20Subscribers-BANGALI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "BENGALI",
                            "categoryid": "9"
                        },
                        {
                            "iddownloadablefiles": "242",
                            "name": "Manage Subscribers",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Manage%20Subscribers-ODIA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "ODIA",
                            "categoryid": "9"
                        },
                        {
                            "iddownloadablefiles": "243",
                            "name": "Manage Subscribers",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Manage%20Subscribers-TAMIL.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "TAMIL",
                            "categoryid": "9"
                        },
                        {
                            "iddownloadablefiles": "244",
                            "name": "Manage Subscribers",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Manage%20Subscribers-TELUGU.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "TELUGU",
                            "categoryid": "9"
                        },
                        {
                            "iddownloadablefiles": "245",
                            "name": "Manage Subscribers",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Manage%20Subscribers-KANNADA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "KANNADA",
                            "categoryid": "9"
                        },
                        {
                            "iddownloadablefiles": "246",
                            "name": "Manage Subscribers",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Manage%20Subscribers-PunjabiiI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "PUNJABI",
                            "categoryid": "9"
                        },
                        {
                            "iddownloadablefiles": "247",
                            "name": "Top Up / Add Packs",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Top%20Up%20%2B%20Add%20Packs-ENGLISH.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "ENGLISH",
                            "categoryid": "10"
                        },
                        {
                            "iddownloadablefiles": "248",
                            "name": "Top Up / Add Packs",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Top%20Up%20%2B%20Add%20Packs-HINDI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "HINDI",
                            "categoryid": "10"
                        },
                        {
                            "iddownloadablefiles": "249",
                            "name": "Top Up / Add Packs",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Top%20Up%20%2B%20Add%20Packs-MARATHI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "MARATHI",
                            "categoryid": "10"
                        },
                        {
                            "iddownloadablefiles": "250",
                            "name": "Top Up / Add Packs",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Top%20Up%20%2B%20Add%20Packs-GUJARATI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "GUJARATI",
                            "categoryid": "10"
                        },
                        {
                            "iddownloadablefiles": "251",
                            "name": "Top Up / Add Packs",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Top%20Up%20%2B%20Add%20Packs-BANGALI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "BENGALI",
                            "categoryid": "10"
                        },
                        {
                            "iddownloadablefiles": "252",
                            "name": "Top Up / Add Packs",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Top%20Up%20%2B%20Add%20Packs-ODIA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "ODIA",
                            "categoryid": "10"
                        },
                        {
                            "iddownloadablefiles": "253",
                            "name": "Top Up / Add Packs",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Top%20Up%20%2B%20Add%20Packs-TAMIL.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "TAMIL",
                            "categoryid": "10"
                        },
                        {
                            "iddownloadablefiles": "254",
                            "name": "Top Up / Add Packs",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Top%20Up%20%2B%20Add%20Packs-TELUGU.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "TELUGU",
                            "categoryid": "10"
                        },
                        {
                            "iddownloadablefiles": "255",
                            "name": "Top Up / Add Packs",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Top%20Up%20%2B%20Add%20Packs-KANNADA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "KANNADA",
                            "categoryid": "10"
                        },
                        {
                            "iddownloadablefiles": "256",
                            "name": "Top Up / Add Packs",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Top%20Up%20%2B%20Add%20Packs-PunjabiiI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "PUNJABI",
                            "categoryid": "10"
                        },
                        {
                            "iddownloadablefiles": "257",
                            "name": "Renew Packs / Stay updated with Latest Announcements",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Renew%20Packs%20%2B%20Stay%20updated%20with%20Latest%20Announcements-ENGLISH.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "ENGLISH",
                            "categoryid": "11"
                        },
                        {
                            "iddownloadablefiles": "258",
                            "name": "Renew Packs / Stay updated with Latest Announcements",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Renew%20Packs%20%2B%20Stay%20updated%20with%20Latest%20Announcements-HINDI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "HINDI",
                            "categoryid": "11"
                        },
                        {
                            "iddownloadablefiles": "259",
                            "name": "Renew Packs / Stay updated with Latest Announcements",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Renew%20Packs%20%2B%20Stay%20updated%20with%20Latest%20Announcements-MARATHI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "MARATHI",
                            "categoryid": "11"
                        },
                        {
                            "iddownloadablefiles": "260",
                            "name": "Renew Packs / Stay updated with Latest Announcements",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Renew%20Packs%20%2B%20Stay%20updated%20with%20Latest%20Announcements-GUJARATI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "GUJARATI",
                            "categoryid": "11"
                        },
                        {
                            "iddownloadablefiles": "261",
                            "name": "Renew Packs / Stay updated with Latest Announcements",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Renew%20Packs%20%2B%20Stay%20updated%20with%20Latest%20Announcements-BANGALI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "BENGALI",
                            "categoryid": "11"
                        },
                        {
                            "iddownloadablefiles": "262",
                            "name": "Renew Packs / Stay updated with Latest Announcements",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Renew%20Packs%20%2B%20Stay%20updated%20with%20Latest%20Announcements-ODIA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "ODIA",
                            "categoryid": "11"
                        },
                        {
                            "iddownloadablefiles": "263",
                            "name": "Renew Packs / Stay updated with Latest Announcements",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Renew%20Packs%20%2B%20Stay%20updated%20with%20Latest%20Announcements-TAMIL.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "TAMIL",
                            "categoryid": "11"
                        },
                        {
                            "iddownloadablefiles": "264",
                            "name": "Renew Packs / Stay updated with Latest Announcements",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Renew%20Packs%20%2B%20Stay%20updated%20with%20Latest%20Announcements-TELUGU.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "TELUGU",
                            "categoryid": "11"
                        },
                        {
                            "iddownloadablefiles": "265",
                            "name": "Renew Packs / Stay updated with Latest Announcements",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Renew%20Packs%20%2B%20Stay%20updated%20with%20Latest%20Announcements-KANNADA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "KANNADA",
                            "categoryid": "11"
                        },
                        {
                            "iddownloadablefiles": "266",
                            "name": "Renew Packs / Stay updated with Latest Announcements",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video2/Short%20Video-Renew%20Packs%20%2B%20Stay%20updated%20with%20Latest%20Announcements-PunjabiiI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "PUNJABI",
                            "categoryid": "11"
                        },
                        {
                            "iddownloadablefiles": "267",
                            "name": "Create Sub-Users",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20Sub%20Users-ENGLISH.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "ENGLISH",
                            "categoryid": "12"
                        },
                        {
                            "iddownloadablefiles": "268",
                            "name": "Create Sub-Users",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20New%20Subscriber%20Details%20%2B%20Bulk%20Processing_HINDI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "HINDI",
                            "categoryid": "12"
                        },
                        {
                            "iddownloadablefiles": "269",
                            "name": "Create Sub-Users",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Create%20New%20Subscriber%20Details%20%2B%20Bulk%20Processing%20MARATHI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "MARATHI",
                            "categoryid": "12"
                        },
                        {
                            "iddownloadablefiles": "270",
                            "name": "Create Sub-Users",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20New%20Subscriber%20Details%20%2B%20Bulk%20Processing_GUJARATI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "GUJARATI",
                            "categoryid": "12"
                        },
                        {
                            "iddownloadablefiles": "271",
                            "name": "Create Sub-Users",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20New%20Subscriber%20Details%20%2B%20Bulk%20Processing_BENGALI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "BENGALI",
                            "categoryid": "12"
                        },
                        {
                            "iddownloadablefiles": "272",
                            "name": "Create Sub-Users",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20New%20Subscriber%20Details%20%2B%20Bulk%20Processing_ODIA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "ODIA",
                            "categoryid": "12"
                        },
                        {
                            "iddownloadablefiles": "273",
                            "name": "Create Sub-Users",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video%20-%20Create%20New%20Subscriber%20Details%20%2B%20Bulk%20Processing_TAMIL.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "TAMIL",
                            "categoryid": "12"
                        },
                        {
                            "iddownloadablefiles": "274",
                            "name": "Create Sub-Users",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video%20-%20Create%20New%20Subscriber%20Details%20%2B%20Bulk%20Processing_TELUGU.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "TELUGU",
                            "categoryid": "12"
                        },
                        {
                            "iddownloadablefiles": "275",
                            "name": "Create Sub-Users",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20New%20Subscriber%20Details%20%2B%20Bulk%20Processing_KANNADA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "KANNADA",
                            "categoryid": "12"
                        },
                        {
                            "iddownloadablefiles": "276",
                            "name": "Create Sub-Users",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20Sub%20Users-PunjabiiI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "PUNJABI",
                            "categoryid": "12"
                        },
                        {
                            "iddownloadablefiles": "277",
                            "name": "Bulk Processing / Create new subscriber",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20New%20Subscriber%20Details%20%2B%20Bulk%20Processing_ENGLISH.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "ENGLISH",
                            "categoryid": "13"
                        },
                        {
                            "iddownloadablefiles": "278",
                            "name": "Bulk Processing / Create new subscriber",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20Sub%20Users-HINDI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "HINDI",
                            "categoryid": "13"
                        },
                        {
                            "iddownloadablefiles": "279",
                            "name": "Bulk Processing / Create new subscriber",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20Sub%20Users-MARATHI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "MARATHI",
                            "categoryid": "13"
                        },
                        {
                            "iddownloadablefiles": "280",
                            "name": "Bulk Processing / Create new subscriber",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20Sub%20Users-GUJARATI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "GUJARATI",
                            "categoryid": "13"
                        },
                        {
                            "iddownloadablefiles": "281",
                            "name": "Bulk Processing / Create new subscriber",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20Sub%20Users-BENGALI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "BENGALI",
                            "categoryid": "13"
                        },
                        {
                            "iddownloadablefiles": "282",
                            "name": "Bulk Processing / Create new subscriber",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20Sub%20Users-ODIA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "ODIA",
                            "categoryid": "13"
                        },
                        {
                            "iddownloadablefiles": "283",
                            "name": "Bulk Processing / Create new subscriber",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video%20-%20Create%20Sub%20Users-TAMIL.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "TAMIL",
                            "categoryid": "13"
                        },
                        {
                            "iddownloadablefiles": "284",
                            "name": "Bulk Processing / Create new subscriber",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video%20-%20Create%20Sub%20Users-TELUGU.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "TELUGU",
                            "categoryid": "13"
                        },
                        {
                            "iddownloadablefiles": "285",
                            "name": "Bulk Processing / Create new subscriber",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20Sub%20Users-KANNADA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "KANNADA",
                            "categoryid": "13"
                        },
                        {
                            "iddownloadablefiles": "286",
                            "name": "Bulk Processing / Create new subscriber",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Create%20New%20Subscriber%20Details%20%2B%20Bulk%20Processing_PunjabiiI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "PUNJABI",
                            "categoryid": "13"
                        },
                        {
                            "iddownloadablefiles": "287",
                            "name": "Business Performance / Comprehensive Reports",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Business%20Performance%20%2B%20Comprehensive%20Reports-ENGLISH.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "ENGLISH",
                            "categoryid": "14"
                        },
                        {
                            "iddownloadablefiles": "288",
                            "name": "Business Performance / Comprehensive Reports",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Business%20Performance%20%2B%20Comprehensive%20Reports-HINDI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "HINDI",
                            "categoryid": "14"
                        },
                        {
                            "iddownloadablefiles": "289",
                            "name": "Business Performance / Comprehensive Reports",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Business%20Performance%20%2B%20Comprehensive%20Reports-MARATHI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "MARATHI",
                            "categoryid": "14"
                        },
                        {
                            "iddownloadablefiles": "290",
                            "name": "Business Performance / Comprehensive Reports",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Business%20Performance%20%2B%20Comprehensive%20Reports-GUJARATI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "GUJARATI",
                            "categoryid": "14"
                        },
                        {
                            "iddownloadablefiles": "291",
                            "name": "Business Performance / Comprehensive Reports",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Business%20Performance%20%2B%20Comprehensive%20Reports-BENGALI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "BENGALI",
                            "categoryid": "14"
                        },
                        {
                            "iddownloadablefiles": "292",
                            "name": "Business Performance / Comprehensive Reports",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Business%20Performance%20%2B%20Comprehensive%20Reports-ODIA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "ODIA",
                            "categoryid": "14"
                        },
                        {
                            "iddownloadablefiles": "293",
                            "name": "Business Performance / Comprehensive Reports",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video%20-%20Business%20Performance%20%2B%20Comprehensive%20Reports-TAMIL.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "TAMIL",
                            "categoryid": "14"
                        },
                        {
                            "iddownloadablefiles": "294",
                            "name": "Business Performance / Comprehensive Reports",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Business%20Performance%20%2B%20Comprehensive%20Reports-TELUGU.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "TELUGU",
                            "categoryid": "14"
                        },
                        {
                            "iddownloadablefiles": "295",
                            "name": "Business Performance / Comprehensive Reports",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Business%20Performance%20%2B%20Comprehensive%20Reports-KANNADA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "KANNADA",
                            "categoryid": "14"
                        },
                        {
                            "iddownloadablefiles": "296",
                            "name": "Business Performance / Comprehensive Reports",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/video1/Short%20Video-Business%20Performance%20%2B%20Comprehensive%20Reports-PunjabiiI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO.png",
                            "category": "PUNJABI",
                            "categoryid": "14"
                        },
                        {
                            "iddownloadablefiles": "297",
                            "name": "Manage Subscribers / Overview of your subscribers / Add packs/ Top up your wallets easily",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%281%29Manage%20Subscribers%20-%20%28a%29%20Overview%20of%20your%20subscribers%20%28b%29%20Add%20packs%20%28c%29%20Top%20up%20your%20wallets%20easily-ENGLISH.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "ENGLISH",
                            "categoryid": "15"
                        },
                        {
                            "iddownloadablefiles": "298",
                            "name": "Manage Subscribers / Overview of your subscribers / Add packs / Top up your wallets easily",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%281%29Manage%20Subscribers%20-%20%28a%29%20Overview%20of%20your%20subscribers%20%28b%29%20Add%20packs%20%28c%29%20Top%20up%20your%20wallets%20easily-HINDI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "HINDI",
                            "categoryid": "15"
                        },
                        {
                            "iddownloadablefiles": "299",
                            "name": "Manage Subscribers / Overview of your subscribers / Add packs / Top up your wallets easily",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%281%29Manage%20Subscribers%20-%20%28a%29%20Overview%20of%20your%20subscribers%20%28b%29%20Add%20packs%20%28c%29%20Top%20up%20your%20wallets%20easily-MARATHI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "MARATHI",
                            "categoryid": "15"
                        },
                        {
                            "iddownloadablefiles": "300",
                            "name": "Manage Subscribers / Overview of your subscribers / Add packs / Top up your wallets easily",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%281%29Manage%20Subscribers%20-%20%28a%29%20Overview%20of%20your%20subscribers%20%28b%29%20Add%20packs%20%28c%29%20Top%20up%20your%20wallets%20easily-GUJARATI%20%281%29.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "GUJARATI",
                            "categoryid": "15"
                        },
                        {
                            "iddownloadablefiles": "301",
                            "name": "Manage Subscribers /Overview of your subscribers / Add packs / Top up your wallets easily",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%281%29Manage%20Subscribers%20-%20%28a%29%20Overview%20of%20your%20subscribers%20%28b%29%20Add%20packs%20%28c%29%20Top%20up%20your%20wallets%20easily-BENGALI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "BENGALI",
                            "categoryid": "15"
                        },
                        {
                            "iddownloadablefiles": "302",
                            "name": "Manage Subscribers /Overview of your subscribers / Add packs / Top up your wallets easily",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%281%29Manage%20Subscribers%20-%20%28a%29%20Overview%20of%20your%20subscribers%20%28b%29%20Add%20packs%20%28c%29%20Top%20up%20your%20wallets%20easily-ODIA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "ODIA",
                            "categoryid": "15"
                        },
                        {
                            "iddownloadablefiles": "303",
                            "name": "Manage Subscribers /Overview of your subscribers / Add packs / Top up your wallets easily",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%281%29Manage%20Subscribers%20-%20%28a%29%20Overview%20of%20your%20subscribers%20%28b%29%20Add%20packs%20%28c%29%20Top%20up%20your%20wallets%20easily-TAMIL.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "TAMIL",
                            "categoryid": "15"
                        },
                        {
                            "iddownloadablefiles": "304",
                            "name": "Manage Subscribers /Overview of your subscribers / Add packs / Top up your wallets easily",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%281%29Manage%20Subscribers%20-%20%28a%29%20Overview%20of%20your%20subscribers%20%28b%29%20Add%20packs%20%28c%29%20Top%20up%20your%20wallets%20easily-TELUGU.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "TELUGU",
                            "categoryid": "15"
                        },
                        {
                            "iddownloadablefiles": "305",
                            "name": "Manage Subscribers /Overview of your subscribers / Add packs / Top up your wallets easily",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%281%29Manage%20Subscribers%20-%20%28a%29%20Overview%20of%20your%20subscribers%20%28b%29%20Add%20packs%20%28c%29%20Top%20up%20your%20wallets%20easily-KANNADA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "KANNADA",
                            "categoryid": "15"
                        },
                        {
                            "iddownloadablefiles": "306",
                            "name": "Manage Subscribers /Overview of your subscribers / Add packs / Top up your wallets easily",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%281%29Manage%20Subscribers%20-%20%28a%29%20Overview%20of%20your%20subscribers%20%28b%29%20Add%20packs%20%28c%29%20Top%20up%20your%20wallets%20easily-PunjabiiI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "PUNJABI",
                            "categoryid": "15"
                        },
                        {
                            "iddownloadablefiles": "307",
                            "name": "Perform Transactions / View your subscriber details / Create and manage tickets",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%282%29Perform%20Transactions%20-%20%28a%29%20View%20your%20subscriber%20details%20%28b%29%20Create%20and%20manage%20tickets%20%28c%29%20Resolve%20errors%20easily%20through%20the%20App-%20ENGLISH.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "ENGLISH",
                            "categoryid": "16"
                        },
                        {
                            "iddownloadablefiles": "308",
                            "name": "Perform Transactions / View your subscriber details / Create and manage tickets",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%282%29Perform%20Transactions%20-%20%28a%29%20View%20your%20subscriber%20details%20%28b%29%20Create%20and%20manage%20tickets%20%28c%29%20Resolve%20errors%20easily%20through%20the%20App-%20HINDI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "HINDI",
                            "categoryid": "16"
                        },
                        {
                            "iddownloadablefiles": "309",
                            "name": "Perform Transactions / View your subscriber details / Create and manage tickets",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%282%29Perform%20Transactions%20-%20%28a%29%20View%20your%20subscriber%20details%20%28b%29%20Create%20and%20manage%20tickets%20%28c%29%20Resolve%20errors%20easily%20through%20the%20App-%20MARATHI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "MARATHI",
                            "categoryid": "16"
                        },
                        {
                            "iddownloadablefiles": "310",
                            "name": "Perform Transactions / View your subscriber details / Create and manage tickets",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%282%29Perform%20Transactions%20-%20%28a%29%20View%20your%20subscriber%20details%20%28b%29%20Create%20and%20manage%20tickets%20%28c%29%20Resolve%20errors%20easily%20through%20the%20App-%20GUJARATI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "GUJARATI",
                            "categoryid": "16"
                        },
                        {
                            "iddownloadablefiles": "311",
                            "name": "Perform Transactions / View your subscriber details / Create and manage tickets",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%282%29Perform%20Transactions%20-%20%28a%29%20View%20your%20subscriber%20details%20%28b%29%20Create%20and%20manage%20tickets%20%28c%29%20Resolve%20errors%20easily%20through%20the%20App-%20BENGALI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "BENGALI",
                            "categoryid": "16"
                        },
                        {
                            "iddownloadablefiles": "312",
                            "name": "Perform Transactions / View your subscriber details / Create and manage tickets",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%282%29Perform%20Transactions%20-%20%28a%29%20View%20your%20subscriber%20details%20%28b%29%20Create%20and%20manage%20tickets%20%28c%29%20Resolve%20errors%20easily%20through%20the%20App-%20ODIA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "ODIA",
                            "categoryid": "16"
                        },
                        {
                            "iddownloadablefiles": "313",
                            "name": "Perform Transactions / View your subscriber details / Create and manage tickets",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%282%29Perform%20Transactions%20-%20%28a%29%20View%20your%20subscriber%20details%20%28b%29%20Create%20and%20manage%20tickets%20%28c%29%20Resolve%20errors%20easily%20through%20the%20App-%20TAMIL.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "TAMIL",
                            "categoryid": "16"
                        },
                        {
                            "iddownloadablefiles": "314",
                            "name": "Perform Transactions / View your subscriber details / Create and manage tickets",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%282%29Perform%20Transactions%20-%20%28a%29%20View%20your%20subscriber%20details%20%28b%29%20Create%20and%20manage%20tickets%20%28c%29%20Resolve%20errors%20easily%20through%20the%20App-TELUGU.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "TELUGU",
                            "categoryid": "16"
                        },
                        {
                            "iddownloadablefiles": "315",
                            "name": "Perform Transactions / View your subscriber details / Create and manage tickets",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%282%29Perform%20Transactions%20-%20%28a%29%20View%20your%20subscriber%20details%20%28b%29%20Create%20and%20manage%20tickets%20%28c%29%20Resolve%20errors%20easily%20through%20the%20App-KANNADA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "KANNADA",
                            "categoryid": "16"
                        },
                        {
                            "iddownloadablefiles": "316",
                            "name": "Perform Transactions / View your subscriber details / Create and manage tickets",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%282%29Perform%20Transactions%20-%20%28a%29%20View%20your%20subscriber%20details%20%28b%29%20Create%20and%20manage%20tickets%20%28c%29%20Resolve%20errors%20easily%20through%20the%20App-%20PunjabiiI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "PUNJABI",
                            "categoryid": "16"
                        },
                        {
                            "iddownloadablefiles": "317",
                            "name": "Latest Announcements / Access all reports for your business / Change your email ID or mobile number",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%283%29Latest%20Announcements%20-%20%28a%29%20Access%20all%20reports%20for%20your%20business%20%28b%29%20Change%20your%20email%20ID%20or%20mobile%20number%20%28c%29%20Add%20sub-users%2C%20and%20stay%20updated%20-ENGLISH.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "ENGLISH",
                            "categoryid": "17"
                        },
                        {
                            "iddownloadablefiles": "318",
                            "name": "Latest Announcements / Access all reports for your business / Change your email ID or mobile number",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%283%29Latest%20Announcements%20-%20%28a%29%20Access%20all%20reports%20for%20your%20business%20%28b%29%20Change%20your%20email%20ID%20or%20mobile%20number%20%28c%29%20Add%20sub-users%2C%20and%20stay%20updated%20-HINDI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "HINDI",
                            "categoryid": "17"
                        },
                        {
                            "iddownloadablefiles": "319",
                            "name": "Latest Announcements / Access all reports for your business / Change your email ID or mobile number",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%283%29Latest%20Announcements%20-%20%28a%29%20Access%20all%20reports%20for%20your%20business%20%28b%29%20Change%20your%20email%20ID%20or%20mobile%20number%20%28c%29%20Add%20sub-users%2C%20and%20stay%20updated%20-MARATHI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "MARATHI",
                            "categoryid": "17"
                        },
                        {
                            "iddownloadablefiles": "320",
                            "name": "Latest Announcements / Access all reports for your business / Change your email ID or mobile number",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%283%29Latest%20Announcements%20-%20%28a%29%20Access%20all%20reports%20for%20your%20business%20%28b%29%20Change%20your%20email%20ID%20or%20mobile%20number%20%28c%29%20Add%20sub-users%2C%20and%20stay%20updated%20-GUJARATI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "GUJARATI",
                            "categoryid": "17"
                        },
                        {
                            "iddownloadablefiles": "321",
                            "name": "Latest Announcements / Access all reports for your business / Change your email ID or mobile number",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%283%29Latest%20Announcements%20-%20%28a%29%20Access%20all%20reports%20for%20your%20business%20%28b%29%20Change%20your%20email%20ID%20or%20mobile%20number%20%28c%29%20Add%20sub-users%2C%20and%20stay%20updated%20-%20BENGALI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "BENGALI",
                            "categoryid": "17"
                        },
                        {
                            "iddownloadablefiles": "322",
                            "name": "Latest Announcements / Access all reports for your business / Change your email ID or mobile number",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%283%29Latest%20Announcements%20-%20%28a%29%20Access%20all%20reports%20for%20your%20business%20%28b%29%20Change%20your%20email%20ID%20or%20mobile%20number%20%28c%29%20Add%20sub-users%2C%20and%20stay%20updated%20-ODIA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "ODIA",
                            "categoryid": "17"
                        },
                        {
                            "iddownloadablefiles": "323",
                            "name": "Latest Announcements / Access all reports for your business / Change your email ID or mobile number",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%283%29Latest%20Announcements%20-%20%28a%29%20Access%20all%20reports%20for%20your%20business%20%28b%29%20Change%20your%20email%20ID%20or%20mobile%20number%20%28c%29%20Add%20sub-users%2C%20and%20stay%20updated%20-TAMIL.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "TAMIL",
                            "categoryid": "17"
                        },
                        {
                            "iddownloadablefiles": "324",
                            "name": "Latest Announcements / Access all reports for your business / Change your email ID or mobile number",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%283%29Latest%20Announcements%20-%20%28a%29%20Access%20all%20reports%20for%20your%20business%20%28b%29%20Change%20your%20email%20ID%20or%20mobile%20number%20%28c%29%20Add%20sub-users%2C%20and%20stay%20updated%20-TELUGU.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "TELUGU",
                            "categoryid": "17"
                        },
                        {
                            "iddownloadablefiles": "325",
                            "name": "Latest Announcements / Access all reports for your business / Change your email ID or mobile number",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%283%29Latest%20Announcements%20-%20%28a%29%20Access%20all%20reports%20for%20your%20business%20%28b%29%20Change%20your%20email%20ID%20or%20mobile%20number%20%28c%29%20Add%20sub-users%2C%20and%20stay%20updated%20-KANNADA.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "KANNADA",
                            "categoryid": "17"
                        },
                        {
                            "iddownloadablefiles": "326",
                            "name": "Latest Announcements / Access all reports for your business / Change your email ID or mobile number",
                            "filename": "SHORT HELP VIDEOS",
                            "purpose": "HELP VIDEO",
                            "created": "2024-07-01 10:08:36",
                            "type": "MP4",
                            "url": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Help%20Videos%20Mobile%20App/Short%20Video%20-%20%283%29Latest%20Announcements%20-%20%28a%29%20Access%20all%20reports%20for%20your%20business%20%28b%29%20Change%20your%20email%20ID%20or%20mobile%20number%20%28c%29%20Add%20sub-users%2C%20and%20stay%20updated%20-PunjabiiI.mp4",
                            "thumbnail": "https://s3.ap-south-1.amazonaws.com/in.nxtdigital.portal.docs/Help%20Videos/Thumbnails_LCO%20APP.png",
                            "category": "PUNJABI",
                            "categoryid": "17"
                        }
                    ])
                    return
                }
                reject(error);
            });
        });
    }

};

export default {
    state, getters, mutations, actions
};



// WEBPACK FOOTER //
// ./src/store/modules/downloadModule.js